import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router'
import { PageName } from '@/models/enums'
import { IS_DEV } from '@/config/api'
import { i18n } from '@/i18n'
const $t = i18n.global.t
const noSetTitleList = [PageName.LOGIN, PageName.PERSONAL, PageName.SETTING]
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: { name: PageName.MAIN },
  },
  {
    path: '/',
    name: PageName.MAIN,
    component: () => import('@/views/main/index.vue'),
    redirect: { name: PageName.HOME },
    children: [
      {
        path: '/home',
        name: PageName.HOME,
        component: () => import('@/views/home/index.vue'),
        meta: {
          isAuthn: false,
        },
      },
      {
        path: '/community',
        name: PageName.COMMUNITY,
        component: () => import('@/views/community/index.vue'),
        meta: {
          isAuthn: false,
        },
      },
      {
        path: '/profile',
        name: PageName.PROFILE,
        component: () => import('@/views/profile/index.vue'),
        meta: {
          isAuthn: false,
        },
      },
    ],
  },
  {
    path: '/aerial-journey/:journey_id/:hotspot/:is_started',
    name: PageName.AERIAL,
    component: () => import('@/views/aerial/index.vue'),
    meta: {
      isAuthn: true,
    },
  },
  {
    path: '/aerial-finish/:ticket_id/:is_error?',
    name: PageName.AERIAL_FINISH,
    component: () => import('@/views/aerial-finish/index.vue'),
    meta: {
      isAuthn: true,
    },
  },
  {
    path: '/login',
    name: PageName.LOGIN,
    component: () => import('@/views/login/index.vue'),
    meta: {
      isAuthn: false,
    },
  },
  {
    path: '/mpweixin',
    name: PageName.MPWEIXIN,
    component: () => import('@/views/actions/index.vue'),
    meta: {
      isAuthn: false,
    },
  },
  {
    path: '/miniprogram',
    name: PageName.MINIPROGRAM,
    component: () => import('@/views/actions/index.vue'),
    meta: {
      isAuthn: false,
    },
  },
  {
    path: '/quick-book',
    name: PageName.QUICK_BOOK,
    component: () => import('@/views/quick-book/index.vue'),
    meta: {
      isAuthn: false,
    },
  },
  {
    path: '/memory/detail/:journey_id/:ticket_id?',
    name: PageName.MEMORY_DETAIL,
    component: () => import('@/views/memory-detail/index.vue'),
    meta: {
      isAuthn: true,
      title: 'memoryPage.hotpotDetailPage.title',
    },
  },
  {
    path: '/memory/download/:ticket_id/:lang?',
    name: PageName.MEMORY_DOWNLOAD,
    component: () => import('@/views/memory-download/index.vue'),
    meta: {
      isAuthn: false,
      title: 'memoryPage.videoPage.title',
    },
  },
  {
    path: '/order/order-detail/:ticket_id/:is_change?:journey_id?',
    name: PageName.ORDER_DETAIL,
    component: () => import('@/views/order-detail/index.vue'),
    meta: {
      isAuthn: true,
      title: 'orderPage.orderDetailPage.title',
    },
  },
  {
    path: '/profile/notice',
    name: PageName.NOTICE,
    component: () => import('@/views/notice/index.vue'),
    meta: {
      isAuthn: true,
      title: 'profilePage.noticePage.title',
    },
  },
  {
    path: '/profile/notice/notice-detail/:id',
    name: PageName.NOTICE_DETAIL,
    component: () => import('@/views/notice-detail/index.vue'),
    meta: {
      isAuthn: true,
      title: 'profilePage.noticePage.noticeDetailsPage.title',
    },
  },
  {
    path: '/profile/language',
    name: PageName.LANGUAGE,
    component: () => import('@/views/language/index.vue'),
    meta: {
      isAuthn: false,
      title: 'profilePage.switchLanguagePage.title',
    },
  },
  {
    path: '/profile/setting',
    name: PageName.SETTING,
    component: () => import('@/views/setting/index.vue'),
    meta: {
      isAuthn: true,
      title: 'profilePage.settingPage.title',
    },
  },
  {
    path: '/profile/setting/service-agreement',
    name: PageName.SERVICE_AGREEMENT,
    component: () => import('@/views/service-agreement/index.vue'),
    meta: {
      isAuthn: false,
      title: 'profilePage.serviceAgreementPage.title',
    },
  },
  {
    path: '/profile/setting/modify-pn',
    name: PageName.MODIFY_PN,
    component: () => import('@/views/modify-phone/index.vue'),
    meta: {
      isAuthn: true,
      title: 'profilePage.changePhoneNumberPage.title',
    },
  },
  {
    path: '/profile/setting/privacy-policy',
    name: PageName.PRIVACY_POLICY,
    component: () => import('@/views/privacy-policy/index.vue'),
    meta: {
      isAuthn: false,
      title: 'profilePage.privacyPolicyPage.title',
    },
  },
  {
    path: '/profile/setting/about-mss',
    name: PageName.ABOUT_MSS,
    component: () => import('@/views/about/index.vue'),
    meta: {
      isAuthn: true,
      title: 'profilePage.aboutMssPage.title',
    },
  },
  {
    path: '/mss-wechat',
    name: PageName.WECHAT,
    component: () => import('@/views/wechat/index.vue'),
    meta: {
      isAuthn: false,
    },
  },
  {
    path: '/personal',
    name: PageName.PERSONAL,
    component: () => import('@/views/personal/index.vue'),
    meta: {
      isAuthn: true,
      title: 'personalPage.title',
    },
  },
  {
    path: '/order',
    name: PageName.ORDER,
    component: () => import('@/views/order/index.vue'),
    meta: {
      isAuthn: true,
      title: 'orderPage.title',
    },
  },
  {
    path: '/post-detail/:post_id',
    name: PageName.POST_DETAIL,
    component: () => import('@/views/post-detail/index.vue'),
    meta: {
      isAuthn: true,
    },
  },
  {
    // type 1：预定成功 2：兑换成功 3：改签成功
    path: '/reservation-success/:ticket_id/:type',
    name: PageName.RESERVATION_SUCCESS,
    component: () => import('@/views/reservation-success/index.vue'),
    meta: {
      isAuthn: false,
    },
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/',
  },
]

const setTitle = (to: any) => {
  const name = to?.name as PageName
  const title = to.meta?.title ?? ''
  if (noSetTitleList.includes(name) && useGlobalStore().inMP) return
  document.title = title ? $t(title) : $t('title')
}

export const router = createRouter({
  history: createWebHistory(),
  routes: routes,
})

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  useGlobalStore().setAppLoad(true)
  const name = to.name as PageName
  const userStore = useUserStore()

  // 记录登录前的页面
  if (from.name && to.name === PageName.LOGIN) {
    userStore.pageNameBeforeLogin = from.name as any
  }

  // 小程序中訪問登錄頁面直接跳轉到小程序的登錄頁面
  if (name === PageName.LOGIN && useGlobalStore().inMP) {
    window.uni.navigateTo({
      url: `/pages/login/index?redirect=${encodeURIComponent(window.location.href)}`,
    })
    return next(false)
  }

  // 小程序中訪問設置頁面直接跳轉到小程序的設置頁面
  if (name === PageName.SETTING && useGlobalStore().inMP) {
    window.uni.navigateTo({
      url: `/pages-settings/index/index?redirect=${encodeURIComponent(window.location.href)}`,
    })
    return next(false)
  }

  // 小程序中訪問個人頁面直接跳轉到小程序的個人頁面
  if (name === PageName.PERSONAL && useGlobalStore().inMP) {
    window.uni.navigateTo({
      url: `/pages-profile/detail/index?redirect=${encodeURIComponent(window.location.href)}`,
    })
    return next(false)
  }

  if (!to.meta.isAuthn) {
    // 检查重定向来源，避免死循环
    // 配合小程序的跳转，避免重复重定向
    if (to.redirectedFrom && useGlobalStore().inMP) {
      const redirectPath = to.redirectedFrom.path

      // 记录已处理的重定向路径，防止循环重定向
      const redirectKey = `redirect_${redirectPath}`
      console.log('redirectKey', redirectKey)
      if (sessionStorage.getItem(redirectKey)) {
        console.log('检测到重复重定向，直接通过', redirectKey)
        useGlobalStore().setAppLoad(false)
        return next()
      }

      // 标记此路径已被重定向处理过
      sessionStorage.setItem(redirectKey, 'true')

      if (redirectPath.includes('service-agreement') && to.name !== PageName.SERVICE_AGREEMENT) {
        return next({ name: PageName.SERVICE_AGREEMENT })
      }
      if (redirectPath.includes('privacy-policy') && to.name !== PageName.PRIVACY_POLICY) {
        return next({ name: PageName.PRIVACY_POLICY })
      }
      if (
        (redirectPath.includes('home') || redirectPath.includes('mpweixin')) &&
        to.name !== PageName.HOME
      ) {
        return next({ name: PageName.HOME })
      }
      if (redirectPath.includes('profile') && to.name !== PageName.PROFILE) {
        return next({ name: PageName.PROFILE })
      }
      if (
        redirectPath.includes('order') &&
        to.redirectedFrom?.query?.ticket_id &&
        to.name !== PageName.ORDER_DETAIL
      ) {
        return next({
          name: PageName.ORDER,
          query: { ticket_id: to.redirectedFrom.query.ticket_id.toString() },
        })
      }
      if (redirectPath.includes('order') && to.name !== PageName.ORDER) {
        return next({ name: PageName.ORDER })
      }
      if (redirectPath.includes('aerial-journey') && to.name !== PageName.AERIAL) {
        const path = to.redirectedFrom.params.pathMatch as string
        return next(path)
      }
    }
    return next()
  } else {
    if (userStore.checkTokenIsExpired()) {
      useGlobalStore().setAppLoad(false)
      return next({ name: PageName.HOME })
    } else {
      userStore.setUserTokens()
      useGlobalStore().setAppLoad(false)
      return next()
    }
  }
})

// 添加全局后置守卫
router.afterEach((to, from) => {
  useGlobalStore().setAppLoad(false)
  const userStore = useUserStore()
  setTitle(to)
  if (from.name === PageName.LOGIN && to.name === PageName.HOME && userStore.checkIsLogin) {
    userStore.loginToReservation = true
  } else {
    userStore.loginToReservation = false
  }
})

router.onError((error, to) => {
  console.error(`路由跳转${String(to.name)}失败`, error)

  if (
    !import.meta.env.DEV &&
    useGlobalStore().inMP &&
    (error.message.includes('Failed to fetch dynamically imported module') ||
      error.message.includes('Importing a module script failed'))
  ) {
    // 打包更新后，旧文件找不到，重新进入要进入的页面清除缓存
    window.location.href = `${window.location.origin}${window.location.hash ? `?t=${+new Date()}#${to.fullPath}` : to.fullPath}`
  }
})
